import { useEffect, useState } from "react";

import type { RepositoryIndexingInsight } from "../types";

import { getIndexingRunInsightsAsUser } from "../dashboard-client";
import { formatErrorMessage } from "../utils/errors";

interface InsightsState {
  insights: RepositoryIndexingInsight[];
  loading: boolean;
  error: string | null;
}

const initialState: InsightsState = {
  error: null,
  insights: [],
  loading: false,
};

export function useRepositoryIndexingInsights(
  runId: string | null,
  repositorySlug?: string | null,
) {
  const [state, setState] = useState<InsightsState>(initialState);

  useEffect(() => {
    if (!runId) {
      setState(initialState);
      return;
    }
    let canceled = false;
    setState((current) => ({ ...current, error: null, loading: true }));
    void getIndexingRunInsightsAsUser({
      path: { runId },
      query: { repositorySlug: repositorySlug ?? undefined },
    })
      .then((res) => res.data.insights as RepositoryIndexingInsight[])
      .then((insights) => {
        if (!canceled) {
          setState({ error: null, insights, loading: false });
        }
      })
      .catch((error: unknown) => {
        if (!canceled) {
          setState({
            error: formatErrorMessage(error),
            insights: [],
            loading: false,
          });
        }
      });
    return () => {
      canceled = true;
    };
  }, [runId, repositorySlug]);

  return state;
}
